import api from '@/lib/api'
import { defineStore, acceptHMRUpdate } from 'pinia'
import { ref, watch } from 'vue'
import { DateTime } from 'luxon'

export const useLogsStore = defineStore('logs', () => {
  const now = new Date()
  const syncLogs = ref([])
  const filters = ref({ availableObjects: [], objects: [], startDate: new Date(now.setDate(now.getDate() - 1)), endDate: undefined, onlyError: true, onlyRecords: true, selectedButtons: ['onlyRecords'] })
  const loadingStuff = ref(false)

  const fetchSyncLogs = async () => {
    loadingStuff.value = true
    if (filters.value.startDate) {
      const response = await api.get(`/hk/v1/sync-logs?objects=${filters.value.objects.join(',')}&startDate=${new Date(filters.value.startDate).toISOString()}&endDate=${filters.value.endDate ? new Date(filters.value.endDate).toISOString() : ''}&onlyError=${filters.value.selectedButtons.includes('onlyError')}&hasRecords=${filters.value.selectedButtons.includes('onlyRecords')}`)
      syncLogs.value = response.map(el => parseElement(el))
      _syncLogs = [...syncLogs.value]
    }
    if (syncLogs.value.length && !filters.value.availableObjects.length) {
      const { data } = await api.get('/hk/v1/configuration/mapped-objects-list')
      filters.value.availableObjects = data
    }
    loadingStuff.value = false
  }

  const hasToShow = (el) => {
    return (!filters.value.objects.length || filters.value.objects.includes(el.object)) &&
    (new Date(el.createddate) > new Date(filters.value.startDate)) &&
    (!filters.value.endDate || new Date(el.createddate) < new Date(filters.value.endDate)) &&
    (!filters.value.selectedButtons.includes('onlyError') || el.status === 'Failed') &&
    (!filters.value.selectedButtons.includes('onlyRecords') || el.status === 'Failed' || el.hasrecords)
  }

  const parseElement = (el) => {
    if (el.startdate && el.enddate) {
      const interval = DateTime.fromISO(el.startdate).until(DateTime.fromISO(el.enddate))
      // @ts-ignore
      const i = interval.toDuration(['milliseconds', 'seconds', 'minutes', 'hours', 'days']).toObject()
      // @ts-ignore
      const duration = (new Intl.DurationFormat('en', { style: 'narrow' }).format(i)).split(' ')
      el.formattedDuration = duration[0] + ' ' + (duration[1] || '')
    }
    return el
  }

  let timeout
  let _syncLogs = []
  const updateSyncLogs = async (element) => {
    if (hasToShow(element)) {
      element = parseElement(element)
      const index = _syncLogs.findIndex(el => el.id <= element.id)
      if (index >= 0 && _syncLogs[index].id === element.id) {
        _syncLogs[index] = element
      } else {
        _syncLogs.splice(index, 0, element)
      }
      clearTimeout(timeout)
      timeout = setTimeout(() => { syncLogs.value = [..._syncLogs] }, 200)
    }
  }

  watch(filters.value, fetchSyncLogs)

  return {
    syncLogs,
    filters,
    loadingStuff,
    updateSyncLogs,
    fetchSyncLogs
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useLogsStore, import.meta.hot))
}
